import { Breadcrumb } from 'modules/model-json';

export const SEASON_START_BREADCRUMBS: Breadcrumb[] = [
  {
    label: 'Главная',
    link: '/',
  },
  {
    label: 'Пора-пора за выгодой',
    link: '/promo/pora-pora/',
  },
];